module.exports = __webpack_public_path__ + "img/box_black_size.2817d30c.svg";